// Analiza S01 — suma losowania. Dane wejsciowe z <script type="application/json" id="sumy-dane">
// (patrz app/templates/analizy/sumy.html.twig). Ustawia window.PEWNIAKI_ANALIZA,
// ktory przelacza assets/js/pages/analiza.js.
(function () {
    var dataEl = document.getElementById('sumy-dane');
    if (!dataEl) return;
    var cfg = JSON.parse(dataEl.textContent);
    var sumyText = cfg.texts;
    var dec = cfg.dec;

    function sumySentence(key, vars) {
        return sumyText[key].replace(/\$\{([^}]+)\}/g, function (_, k) { return String(vars[k]); });
    }

    function liczbySrodkowe(okno) {
        var hist = okno && okno.hist || {}, total = Number(okno && okno.losowan || 0);
        var keys = Object.keys(hist).map(Number).sort(function (a, b) { return a - b; });
        if (!total || !keys.length || !cfg.typuje || !cfg.pula || !cfg.wybiera) return null;
        var cumulative = 0, lower = null, upper = null;
        keys.forEach(function (sum) {
            cumulative += Number(hist[sum]) || 0;
            if (lower === null && cumulative > (total - 1) / 2) lower = sum;
            if (upper === null && cumulative > total / 2) upper = sum;
        });
        if (lower === null || upper === null) return null;
        var median = (lower + upper) / 2, center = median / Number(cfg.typuje);
        var numbers = Array.from({ length: Number(cfg.pula) }, function (_, i) { return i + 1; });
        numbers.sort(function (a, b) { return Math.abs(a - center) - Math.abs(b - center) || a - b; });
        return { median: median, center: center, numbers: numbers.slice(0, Number(cfg.wybiera)).sort(function (a, b) { return a - b; }) };
    }
    var kopiujButton=document.querySelector('[data-sumy-kopiuj]');
    if (kopiujButton) kopiujButton.addEventListener('click', function () {
        var ballNodes=document.querySelectorAll('[data-sumy-wybor] .kula'), status=document.querySelector('[data-sumy-kopiuj-status]');
        var value=Array.from(ballNodes, function (el) { return el.textContent.trim(); }).join(' ');
        if (!value || !navigator.clipboard || !navigator.clipboard.writeText) {
            if (status) status.textContent=sumyText['sumy.numbers.copy_error'];
            return;
        }
        navigator.clipboard.writeText(value).then(function () {
            if (status) status.textContent=sumyText['sumy.numbers.copied'];
        }, function () {
            if (status) status.textContent=sumyText['sumy.numbers.copy_error'];
        });
    });

    window.PEWNIAKI_ANALIZA = {
        plik: '/assets/json/db/' + cfg.kod + '/analizy/sumy.json',
        wersja: cfg.wersja,
        lata: '/assets/json/db/' + cfg.kod + '/lata/',
        // Zakres lat: suma SUROWYCH licznikow sum z rocznikow (plan V2 §5.3).
        sumujLata: function (roczniki) {
            var hist = {}, N = 0;
            roczniki.forEach(function (r) {
                N += r.losowan || 0;
                Object.keys(r.sumy || {}).forEach(function (s) { hist[s] = (hist[s] || 0) + r.sumy[s]; });
            });
            var suma = 0; Object.keys(hist).forEach(function (s) { suma += s * hist[s]; });
            return { losowan: N, hist: hist, srednia: N ? Math.round(suma / N * 10) / 10 : null,
                     ostatnia: null, pct_hist: null, pct_model: null, autokorelacja: null };
        },
        wnioski: function (o, klucz, dane) {
            if (!o || o.powod || !Number.isInteger(o.losowan) || o.losowan <= 0) return [sumyText['sumy.missing']];
            var p = [];
            var model = dane && dane.model;
            if (Number.isFinite(o.srednia)) p.push(sumySentence(model && Number.isFinite(model.srednia) ? 'sumy.js.mean' : 'sumy.js.mean_only', {n:o.losowan,mean:String(o.srednia).replace('.',dec),model:model && String(model.srednia).replace('.',dec)}));
            if (o.ostatnia != null && o.pct_model != null) p.push(sumySentence('sumy.js.last', {last:o.ostatnia,pct:o.pct_model}));
            return p.length ? p : [sumyText['sumy.none']];
        },
        render: function (okno, klucz, dane) {
            var q = function (s) { return document.querySelector(s); };
            // Histogram SSR dotyczy okna wczytanego przy starcie — po kazdej zmianie
            // zakresu chowamy go, zeby nie pokazywac liczb spod innej etykiety.
            if (window.PEWNIAKI_HISTOGRAM) window.PEWNIAKI_HISTOGRAM(q('[data-sumy]'), 'sumy', okno, {model:((dane || {}).model || {}).pmf || {}, latest:okno ? okno.ostatnia : null});
            var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
            var f1 = function (v) { return v == null ? '—' : (Math.round(v * 10) / 10).toString().replace('.', dec); };
            var model = dane.model || {}, pmf = model.pmf || {};
            var sekcja = q('[data-sumy]');
            if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
            if (sekcja) { sekcja.hidden = false; }
            var N = okno.losowan || 0, hist = okno.hist || {};
            var wybor = liczbySrodkowe(okno), kule = q('[data-sumy-wybor]'), opis = q('[data-sumy-metoda]');
            if (kule) {
                kule.replaceChildren();
                (wybor ? wybor.numbers : []).forEach(function (numer) {
                    var wrapper=document.createElement('div'), ball=document.createElement('span');
                    wrapper.className='kula-z-podpisem';
                    ball.className='kula kula--mala kula--'+cfg.kod;
                    ball.textContent=String(numer);
                    wrapper.appendChild(ball);
                    kule.appendChild(wrapper);
                });
            }
            if (opis) opis.textContent=wybor
                ? sumySentence('sumy.numbers.median',{sum:f1(wybor.median),center:f1(wybor.center),n:tys(N)})
                : sumyText['sumy.missing'];
            q('[data-sumy-n]').textContent = tys(N);
            q('[data-sumy-srednia]').textContent = f1(okno.srednia);
            q('[data-sumy-ostatnia]').textContent = okno.ostatnia != null ? okno.ostatnia : '—';
            q('[data-sumy-pct-model]').textContent = okno.pct_model != null ? Number(okno.pct_model).toFixed(1).replace('.', dec) + '%' : '—';
            q('[data-sumy-pct-hist]').textContent = okno.pct_hist != null ? Number(okno.pct_hist).toFixed(1).replace('.', dec) + '%' : '—';
            var klucze = Object.keys(hist).map(Number).sort(function (a, b) { return a - b; });
            q('[data-sumy-min]').textContent = klucze.length ? klucze[0] : '—';
            q('[data-sumy-max]').textContent = klucze.length ? klucze[klucze.length - 1] : '—';
            // TOP 10 sum
            var top = klucze.slice().sort(function (a, b) { return hist[b] - hist[a] || a - b; }).slice(0, 10);
            q('[data-sumy-top] tbody').innerHTML = top.map(function (s) {
                return '<tr><td class="liczbowa">' + s + '</td><td class="liczbowa">' + tys(hist[s]) + '</td><td class="liczbowa">'
                     + (N ? f1(hist[s] * 100 / N) : '—') + '%</td><td class="liczbowa">' + (pmf[s] != null ? f1(N * pmf[s]) : '—') + '</td></tr>';
            }).join('');
            // przedzialy po 12
            var min = model.min || (klucze[0] || 0), max = model.max || (klucze[klucze.length - 1] || 0), szer = 12, wiersze = [];
            for (var od = min; od <= max; od += szer) {
                var doP = Math.min(od + szer - 1, max), obs = 0, mod = 0;
                for (var s = od; s <= doP; s++) { obs += hist[s] || 0; mod += pmf[s] || 0; }
                wiersze.push('<tr><td class="liczbowa">' + od + '–' + doP + '</td><td class="liczbowa">' + tys(obs) + '</td><td class="liczbowa">'
                    + (N ? f1(obs * 100 / N) : '—') + '%</td><td class="liczbowa">' + f1(mod * 100) + '%</td></tr>');
            }
            q('[data-sumy-hist] tbody').innerHTML = wiersze.join('');
            // autokorelacja — tylko dla okien; zakres lat to nie ciag
            var ak = okno.autokorelacja, lag = ak && ak.lag ? ak.lag : {};
            q('[data-sumy-ak-n]').textContent = ak && ak.n != null ? tys(ak.n) : '—';
            q('[data-sumy-ak-ci]').textContent = ak && ak.ci95 != null ? ak.ci95 : '—';
            ['1', '2', '3'].forEach(function (L) { q('[data-sumy-lag="' + L + '"]').textContent = lag[L] != null ? lag[L] : '—'; });
            var poza = ak && ak.ci95 != null && ['1', '2', '3'].some(function (L) { return lag[L] != null && Math.abs(lag[L]) > ak.ci95; });
            q('[data-sumy-ak-zdanie]').textContent = !ak
                ? sumyText['sumy.ak.years']
                : (ak.ci95 == null ? sumyText['sumy.ak.small']
                : (poza ? sumySentence('sumy.ak.out', {ci:ak.ci95})
                        : sumyText['sumy.ak.in']));
        }
    };
})();
